<template>
  <teleport v-if="join.kit?.jewelry_count" to="#app">
    <div class="shop-join-tracker flex-row flex-right">
      <a
        href="#"
        @click.prevent="show = !show"
        class="button flex-row flex-center flex-align-center"
        aria-label="Continue signup"
      >
        <i class="pi pi-plus" />
      </a>
      <!-- <div>{{ join.count }} / {{ join.kit.jewelry_count }}</div> -->
      <div v-if="show" class="popup p-lg">
        <div v-if="isCanceling" class="flex-column">
          <div>
            <p class="pa-p1 text-center add-padding">
              Are you sure you want to cancel your <br />
              `{{ join.kit.name }}` enrollment?
            </p>
          </div>
          <div class="flex-row flex-center gap-sm">
            <Button @click="join.clear()">Yes</Button>
            <Button @click="isCanceling = false">No</Button>
          </div>
        </div>
        <div v-else-if="join.count >= join.kit.jewelry_count">
          <h2 class="pa-pink pa-h3">Congratulations</h2>
          <p class="pa-p1 text-center add-padding">
            You have met the required {{ join.kit.jewelry_count }} pieces for
            your

            {{ join.kit.name_without_price }}
          </p>
          <div class="flex-column gap-sm">
            <div class="flex-row gap-sm buttons-sm">
              <RouterLink :to="{ name: 'opportunities-signup' }">
                <Button class="grey text-nowrap">Continue Enrollment</Button>
              </RouterLink>
              <Button
                @click="
                  dismissed = true;
                  show = false;
                "
                class="grey text-nowrap cont-shopping"
                >Continue Shopping
              </Button>
            </div>
            <div class="flex-row flex-center">
              <a href="#" @click.prevent="isCanceling = true">
                Cancel Enrollment
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <h2 class="pa-pink pa-h3 m-sm-b">Add To Bag</h2>
          <p class="pa-p1 text-center m-sm-b add-padding">
            Add {{ join.kit.jewelry_count }} pieces for your<br />
            {{ join.kit.name_without_price }}
          </p>
          <div class="flex-column flex-align-center gap-sm">
            <div class="flex-center">
              <Button @click="show = false" class="grey text-nowrap">
                Shop
              </Button>
            </div>
            <div class="flex-row flex-center">
              <a href="#" @click.prevent="isCanceling = true">
                Cancel Enrollment
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="backdrop" />
  </teleport>
  <Dialog
    v-model:visible="showLargeItemPopup"
    :show-header="false"
    :dismissable-mask="true"
    :modal="true"
    @after-hide="largeItemShown = true"
  >
    <div class="zi-notice p-lg text-center">
      You’ve picked one of our iconic Zi Collection accessories! Choosing this
      item will count as 5 standard pieces.
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { useCartStore } from "@/stores/cart";
import { useJoinStore } from "@/stores/join";
import { useShopStore } from "@/stores/shop";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { onMounted, ref, watch } from "vue";

const cart = useCartStore();
const join = useJoinStore();
const shop = useShopStore();

const isCanceling = ref(false);
const dismissed = ref(false);
const showLargeItemPopup = ref(false);
const largeItemShown = ref(false);
const show = ref(true);
const count = ref(10000);
const required = ref(0);
const knownItems = ref<number[]>([]);

watch(
  () => join.count,
  () => {
    if (count.value < required.value) {
      count.value = Math.max(count.value, join.count);
      if (count.value >= required.value) {
        if (!dismissed.value) {
          show.value = true;
        } else {
          console.log("already dismissed");
        }
      }
    }
  },
);

watch(
  () => cart.object.items,
  () => {
    if (
      (join.kit?.jewelry_count || 0) > 0 &&
      !largeItemShown.value &&
      cart.object.items
    ) {
      const newItems = cart.object.items.filter(
        (item) =>
          !item.promotion &&
          item.product?.id &&
          !knownItems.value.includes(item.product.id),
      );

      const ziRoots = shop.categories.filter((c) =>
        /^zi collection/i.test(c.name),
      );
      const ziAllCategories = ziRoots.map((c) => shop.descendents[c.id]);
      const ziAll = ziAllCategories.flat().map((c) => c.id);

      // if item is in any of the zi roots, then it is a zi item and
      // we need to show the large item popup
      if (
        newItems.some((item) => {
          const product = shop.products.find((p) => p.id === item.product?.id);
          if (product) {
            const matches = product.categories.some((cid: number) =>
              ziAll.includes(cid),
            );
            return matches;
          }
          return false;
        })
      ) {
        showLargeItemPopup.value = true;
      }

      knownItems.value = cart.object.items
        .map((item) => item.product?.id)
        .filter((i) => i) as number[];
    }
  },
  { deep: true },
);

onMounted(() => {
  count.value = join.count;
  required.value = join.kit?.jewelry_count || 0;

  if (cart.object.items) {
    knownItems.value = cart.object.items
      .map((item) => item.product?.id)
      .filter((i) => i) as number[];
  }
});
</script>

<style scoped>
.shop-join-tracker {
  position: fixed;
  right: calc(50vw - 660px);
  top: 262px;
  z-index: 105;
}
.shop-join-tracker .button {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  background: var(--Paparazzi-Pink, #ec008c);
  color: white;
}
.popup {
  position: absolute;
  z-index: -1;
  min-width: 415px;
  top: 28px;
  right: 28px;
  background: white;
  font-size: 14px;

  h2 {
    color: var(--Paparazzi-Pink, #ec008c);

    /* Heading 3 */
    font-family: Indivisible;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  p {
    margin: 0 0 24px 0;
    padding: 0 12px;
  }
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.35);
  z-index: 101;
}

.zi-notice {
  width: 415px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

.pi-plus:before {
  font-size: 26px;
}

@media (max-width: 1400px) {
  .shop-join-tracker {
    right: 60px;
  }
}

@media screen and (max-width: 575px) {
  .popup {
    width: 286px;
    min-width: 100%;
    p {
      padding: var(--Sm, 24px) 0;
    }
    :deep(.buttons-sm) {
      flex-direction: column !important;
      align-items: center;
    }
    p.add-padding {
      padding: 0;
    }
  }
  .zi-notice {
    width: 80vw;
  }
  .shop-join-tracker {
    top: 160px;
  }
  button.cont-shopping {
    width: fit-content;
  }
}

@media screen and (max-width: 450px) {
  .shop-join-tracker {
    right: 10px;
  }
  .popup {
    width: 80vw;
    p {
      padding: var(--Sm, 24px) 0;
    }
  }
}
</style>
